import { useState, useEffect } from 'react';

/**
 * Hook that returns a state to determine whether or not to render
 * a fade gradient during horizontal scroll
 */
export const useScrollFade = (containerId: string) => {
  const [showRightFade, setShowRightFade] = useState(false);

  useEffect(() => {
    const scrollableContainer = document.getElementById(containerId);
    if (!scrollableContainer) {
      return;
    }

    const handleScroll = () => {
      const { scrollLeft, clientWidth, scrollWidth } = scrollableContainer;
      const isAtTableEnd = scrollLeft + clientWidth >= scrollWidth - 1;
      setShowRightFade(!isAtTableEnd);
    };

    let resizeTimeout: ReturnType<typeof setTimeout>;
    const debouncedHandleScroll = () => {
      clearTimeout(resizeTimeout);
      resizeTimeout = setTimeout(handleScroll, 200);
    };

    handleScroll();

    scrollableContainer?.addEventListener('scroll', handleScroll);
    window.addEventListener('resize', debouncedHandleScroll);
    return () => {
      scrollableContainer?.removeEventListener('scroll', handleScroll);
      window.removeEventListener('resize', debouncedHandleScroll);
      clearTimeout(resizeTimeout);
    };
  }, [containerId]);

  return showRightFade;
};
